import { render, staticRenderFns } from "./erp-card.vue?vue&type=template&id=0be60358&"
import script from "./erp-card.vue?vue&type=script&lang=js&"
export * from "./erp-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports